import HIGHLIGHTED_CHIP_CLASS_NAME from '../../constants/chip';

export const highlightedChipStyles = ({ theme, backgroundColor }) => ({
  backgroundColor,
  color: theme.palette.common.white,
  fontWeight: 600,
  '& .MuiChip-icon': {
    color: theme.palette.common.white,
  },
});

const MuiChip = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${HIGHLIGHTED_CHIP_CLASS_NAME}`]: highlightedChipStyles({ theme, backgroundColor: theme.palette.primary.main }),
    }),
  },
};

export default MuiChip;
